import { alpha, typography } from "@mui/system";

const styles = (theme) => ({
  AccordionSummary: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "9px",
    position: "relative",
    content: '""',
  },
  boxComponent: {
    p: 2,
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      width: "10px",
      height: "100%",
    },
  },
  iconDetails: {
    p: 0.5,
    width: 24,
    height: 24,
  },
  boxAtendimentoEstourados: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    maxHeight: "260px",
    overflow: "auto",
    p: 1,
  },
  boxProtocolo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 1,
  },
  boxTimes: {
    mt: 0.5,
    pt: 0.5,
    borderTop: "1px dashed",
    borderColor: "text.secondary",
    display: "flex",
    flexDirection: "column",
    gap: 0.25,
  },
  paperAtendimentoEstourado: {
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : "theme.palette.colors.black.lighter",
    p: 1,

    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  typographyAtendimentoEstourado: {
    fontWeight: "bold",
    fontSize: "12px",
  },
  boxCard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  typographyCliente: {
    fontWeight: "bold",
    fontSize: "12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  valueSla: { fontSize: "13px", fontWeight: 500 },
  icon: {
    fontSize: "18px",
    color: "text.secondary",
  },
  boxTimeSla: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    justifyContent: "center",
  },
  containerValueSla: {
    display: "flex",
    justifyContent: "space-between",
  },
  containerCard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containerDescricaoCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: 0.5,
    minWidth: "80px",
  },
  containerDataSla: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  iconAlertSla: {
    color: theme.palette.warning.main,
    fontSize: "20px",
  },
  titleDescricaoAlertSls: { fontSize: "12px", fontWeight: "bold" },
  boxAlertSla: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "&::after": {
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      border: `2px solid ${theme.palette.warning.main}`,
      animation: "pulse 1.5s infinite",
    },

    "@keyframes pulse": {
      "0%": {
        transform: "scale(0.7)",
        opacity: 0.8,
      },
      "70%": {
        transform: "scale(1.8)",
        opacity: 0,
      },
      "100%": {
        opacity: 0,
      },
    },
  },

  dataRow: {
    fontWeight: "bold",
    fontSize: "12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%", // importante para o corte funcionar
  },
  chipStatus: {
    minWidth: "120px",
    color: theme.palette.white.main,
  },
  containerStatusModal: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  titleChipModal: {
    fontWeight: "bold",
    fontSize: "10px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
});
export default styles;
